import { useLocation, useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import MapIcon from "@mui/icons-material/Map";
import { useAuth } from "@/auth/useAuth";

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const showReports = !!user && user.is_superuser;

  const current = location.pathname.startsWith("/settings")
    ? "settings"
    : location.pathname.startsWith("/reports") && showReports
    ? "reports"
    : "search";

  return (
    <Paper
      elevation={3}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <BottomNavigation
        value={current}
        onChange={(_, newValue) => navigate(`/${newValue}`)} 
        showLabels
      >
        <BottomNavigationAction
          label="Canvass"
          value="search"
          icon={<HomeIcon />}
        />
        {showReports && (
          <BottomNavigationAction
            label="Reports"
            value="reports"
            icon={<MapIcon />}
          />
        )}
        <BottomNavigationAction
          label="Settings"
          value="settings"
          icon={<SettingsIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
}
